<template>
  <form-layout :label="label">
    <read-only-input :value="value!==null?value+' '+unit:''" />
  </form-layout>
</template>

<script>
import ReadOnlyInput from "@/views/atoms/inputs/ReadOnlyInput";
import FormLayout from '@/views/templates/FormLayout';

export default {
  name: "TextBrowseWithUnitItem",
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number, null],
      required: true
    },
    unit: {
      type: [String, null],
      required: true
    },
  },
  components: {
    FormLayout,
    ReadOnlyInput
  }
}
</script>
